import basicSettingApi from '@/api/basicSetting/basicSettingApi'

export default {
	name: 'lte-flag-switch',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			lteFlag: null,
			applyLteFlag: 'D',
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			this.lteFlag = await basicSettingApi.retrieveLteFlag();
		},
		async confirmLteFlagStatus(){
			if(this.applyLteFlag === this.lteFlag){
				$("#myModal").modal('show');
				return;
			}
			let result = await basicSettingApi.changeVoiceService(this.applyLteFlag);
			if(result == '0'){
				this.$router.push({name: 'gt-success', params: { title : '開啟VoLTE', returnName : 'lte-flag-switch' }});
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/lteFlagSwitch/lteFlagSwitch.js